/* components/TabContainer.ts
This uses buttons to toggle content

Use within liquid as:
{! component 'TabContainer', titles: titleArray, contents: contentsArray, class: 'example-tab__container' !}

*/

import { Component, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '../../theme/ThemeComponent';
import { TabHeader } from '../../components/TabHeader/TabHeader';

@Component
export class TabContainer extends ThemeComponent {
    @Ref tabHeader!: TabHeader;
    @Ref tabContent !: HTMLDivElement[];

    init() {
        this.$subscribe(this.tabHeader.onTabChange, this.tabChanged.bind(this));
    }
    private tabChanged(tab: string) {
        const prevActiveButton = this.tabHeader.querySelector('.tab-header__button--active');
        if (prevActiveButton?.getAttribute('value') !== tab) {
            prevActiveButton?.classList.remove('tab-header__button--active');
            this.tabHeader.querySelector(`[value="${tab}"]`)?.classList.add('tab-header__button--active');
        }
        const prevActiveContent = this.querySelector('.tab-content--active');
        if (prevActiveContent?.getAttribute('name') !== tab) {
            prevActiveContent?.classList.remove('tab-content--active');
            for (const content of this.tabContent) {
                if (content.getAttribute('name') === tab) {
                    content.classList.add('tab-content--active');
                }
            }
        }
    }
}
